const textValidator = (value, message) => {
  if (message && value) {
    return message;
  }
  return null;
};

export default textValidator;
